import React from 'react'

import {
  AlignSelf,
  Body2,
  Box,
  Color,
  Display,
  Heading2,
  Heading3,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { HowGoustoFoodBoxesWorkSections, TargetUri, TrackingActions } from '../../types/tracking'
import goustovalue from '../assets/goustovalue.jpg'
import { GOUSTO_VALUE } from './config'

export function GoustoValueSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box bg={Color.NeutralGrey_50}>
      <TwoColumnLayout image={{ src: goustovalue, alt: GOUSTO_VALUE.altText }}>
        <Box alignSelf={AlignSelf.Start}>
          <Heading2 textAlign={TextAlign.Left}>{GOUSTO_VALUE.heading}</Heading2>
          <Space size={3} />
          {GOUSTO_VALUE.benefits.map((benefit) => (
            <Box paddingV={2} key={benefit.title}>
              <Heading3 size={6}>{benefit.title}</Heading3>
              <Body2 size={4}> {benefit.description}</Body2>
            </Box>
          ))}

          <Space size={6} />
          <Box
            display={Display.Flex}
            justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
          >
            <LandingPageButton
              startOnboarding={startOnboarding}
              sectionName={HowGoustoFoodBoxesWorkSections.GOUSTO_VALUE_SECTION}
              target={TargetUri.SIGNUP}
              action={TrackingActions.CLICK_GET_STARTED}
            >
              {GOUSTO_VALUE.ctaText}
            </LandingPageButton>
          </Box>
        </Box>
      </TwoColumnLayout>
    </Box>
  )
}
